"use client";

import { useRouter } from "next/navigation";
import {
  User as UserIcon,
  Settings,
  Phone,
  FileText,
  Shield,
  LogOut,
} from "lucide-react";

import { User } from "@/types/user";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

interface UserDropdownMenuProps {
  user: User;
}

const UserDropdownMenu: React.FC<UserDropdownMenuProps> = ({ user }) => {
  const router = useRouter();

  const handleMenuSelect = (option: string) => {
    switch (option) {
      case "View Profile":
        router.push(`/profile/${user.username}`);
        break;
      case "Settings":
        router.push("/settings");
        break;
      case "Contact Support":
        if (typeof window !== "undefined") {
          const subject = "Support Request";
          const body = "Please describe your issue below:";
          const encodedSubject = encodeURIComponent(subject);
          const encodedBody = encodeURIComponent(body);
          window.location.href = `mailto:support@idyllic.app?subject=${encodedSubject}&body=${encodedBody}`;
        }
        break;
      case "Terms of Service":
        if (typeof window !== "undefined") {
          window.open("https://idyllic.app/terms-conditions/", "_blank");
        }
        break;
      case "Privacy Policy":
        if (typeof window !== "undefined") {
          window.open("https://idyllic.app/privacy-policy/", "_blank");
        }
        break;
      case "Logout":
        router.push("/logout");
        break;
      default:
        break;
    }
  };

  return (
    <DropdownMenuContent align="end" className="tw:w-56 tw:z-[1500]">
      <DropdownMenuItem
        onClick={() => handleMenuSelect("View Profile")}
        className="tw:cursor-pointer"
      >
        View Profile
        <UserIcon className="tw:ml-auto tw:h-4 tw:w-4" />
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => handleMenuSelect("Settings")}
        className="tw:cursor-pointer"
      >
        Settings
        <Settings className="tw:ml-auto tw:h-4 tw:w-4" />
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => handleMenuSelect("Contact Support")}
        className="tw:cursor-pointer"
      >
        Contact Support
        <Phone className="tw:ml-auto tw:h-4 tw:w-4" />
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => handleMenuSelect("Terms of Service")}
        className="tw:cursor-pointer"
      >
        Terms of Service
        <FileText className="tw:ml-auto tw:h-4 tw:w-4" />
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => handleMenuSelect("Privacy Policy")}
        className="tw:cursor-pointer"
      >
        Privacy Policy
        <Shield className="tw:ml-auto tw:h-4 tw:w-4" />
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => handleMenuSelect("Logout")}
        className="tw:cursor-pointer"
      >
        Logout
        <LogOut className="tw:ml-auto tw:h-4 tw:w-4" />
      </DropdownMenuItem>
    </DropdownMenuContent>
  );
};

export default UserDropdownMenu;
